export default class NtProductHero {
  element: HTMLElement;

  constructor(element) {
    this.element = element;

    this.createScrollAnchor();
    console.log('product-hero.init()');
  }

  createScrollAnchor() {
    // Only for full height heroes
    if(!this.element.classList.contains('product-hero--height-full')) {
      return;
    }

    // Get next element after hero, where to scroll
    const nextElement = this.element.nextElementSibling as HTMLElement;
    if (!nextElement) {
      return;
    }

    const wrapper = this.element.querySelector('.product-hero__wrapper');
    if (!wrapper) {
      return;
    }

    const scrollBtn = document.createElement('button');
    scrollBtn.classList.add('button', 'button--outline', 'product-hero__scroll-button');
    scrollBtn.innerHTML = `<span class="icon icon--arrow-down"></span>`;

    wrapper.appendChild(scrollBtn);

    scrollBtn.addEventListener('click', (e) => {
      e.preventDefault();
      nextElement.scrollIntoView({ behavior: 'smooth' });
    });
  }
}

export function init(heroes: NodeListOf<Element>) {
  heroes.forEach(hero => {
    new NtProductHero(hero as HTMLElement);
  });
}
